"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "wasteBins",
    path: "/waste-bins",
    component: "WasteBinsBrowser"
});
let WasteBinsBrowser = class WasteBinsBrowser extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    selectedItems;
    ds;
    async $$load_ds() {
        return this.$fn.slickDataSource('browse_waste_bins');
    }
    ux;
    b_7315092382398562_modalBindings;
    b_2248226175642056_columnDefaults;
    b_2248226175642056_columns;
    dataMembers = ['selectedItems', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                selectedItems: [],
                ds: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_2248226175642056_columnDefaults: {
                    sortable: true,
                    filterable: true,
                    resizable: true,
                },
                b_2248226175642056_columns: [{
                        field: "name",
                        name: this.$fn.pgettext("WasteBinsBrowser", "Name"),
                        formatter: {
                            name: "routeLink",
                            to: "fixedAsset",
                            params: {
                                id: "id",
                            },
                        },
                    },
                    {
                        field: "bin_capacity_liters",
                        type: "number",
                        name: this.$fn.pgettext("WasteBinsBrowser", "Capacity (liters)"),
                        formatter: "number",
                    },
                    {
                        field: "waste_bin_name",
                        name: this.$fn.pgettext("WasteBinsBrowser", "Bin Name"),
                    },
                    {
                        field: "worksheets",
                        name: this.$fn.pgettext("WasteBinsBrowser", "Worksheets"),
                    },
                    {
                        field: "bin_type",
                        name: this.$fn.pgettext("WasteBinsBrowser", "Bin Type"),
                        formatter: {
                            name: "gettext",
                            context: "WasteBinTypes",
                            conversion: "StartCase",
                        },
                    },
                    {
                        field: "rental_name",
                        name: this.$fn.pgettext("WasteBinsBrowser", "Rental"),
                        formatter: {
                            name: "routeLink",
                            to: "rental",
                            navigateOnIconClick: true,
                            params: {
                                id: "rental_id",
                            },
                        },
                    },
                    {
                        field: "rental_client_name",
                        name: this.$fn.pgettext("WasteBinsBrowser", "Tenant"),
                        formatter: {
                            name: "routeLink",
                            to: "company",
                            navigateOnIconClick: true,
                            params: {
                                id: "rental_client_id",
                            },
                        },
                    },
                    {
                        field: "created_at",
                        name: this.$fn.pgettext("BrowserColumn", "Create time"),
                        formatter: "datetime",
                    },
                ],
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.gettext("Waste Bins"),
                icon: this.$config.wasteBin.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_2012_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_setData_2014_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: this.$refs.grid.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_2248226175642056_selectedRowsChanged(event, scope) {
        return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    async act_6466705138206980_showModal_2016_getActionArgs($event) {
        return {
            name: "MCreateFixedAsset",
            props: {
                assetType: "waste_bin",
            },
        };
    }
    async evh_6466705138206980_click(event, scope) {
        return await this.actions.evh_6466705138206980_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_2012 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_2012_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_2011 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_2012,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_2011],
        });
        const act_2248226175642056_setData_2014 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2248226175642056_setData_2014_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_selectedRowsChanged_2013 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_setData_2014,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_2248226175642056_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_selectedRowsChanged_2013],
        });
        const act_6466705138206980_showModal_2016 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_6466705138206980_showModal_2016_getActionArgs,
            events: [],
        });
        const evh_6466705138206980_click_2015 = new core_1.actions.EventHandlerImpl({
            action: act_6466705138206980_showModal_2016,
            event: "click",
            displayName: "showModal",
        });
        const evh_6466705138206980_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6466705138206980_click_2015],
        });
        return {
            act_7315092382398562_closeModal_2012,
            evh_7315092382398562_close_2011,
            evh_7315092382398562_close,
            act_2248226175642056_setData_2014,
            evh_2248226175642056_selectedRowsChanged_2013,
            evh_2248226175642056_selectedRowsChanged,
            act_6466705138206980_showModal_2016,
            evh_6466705138206980_click_2015,
            evh_6466705138206980_click,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], WasteBinsBrowser.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WasteBinsBrowser.prototype, "onSize", null);
WasteBinsBrowser = __decorate([
    (0, vue_property_decorator_1.Component)()
], WasteBinsBrowser);
exports.default = WasteBinsBrowser;
vue_property_decorator_1.Vue.component("WasteBinsBrowser", WasteBinsBrowser);
